import { render, staticRenderFns } from "./VaAudioFileInput.vue?vue&type=template&id=481707d6&scoped=true&"
import script from "./VaAudioFileInput.vue?vue&type=script&lang=js&"
export * from "./VaAudioFileInput.vue?vue&type=script&lang=js&"
import style0 from "./VaAudioFileInput.vue?vue&type=style&index=0&id=481707d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481707d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VFileInput,VIcon})
